import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AboutUs.css";
import followersImage from "../Pages/Images/followers.webp";
import helpersImage from "../Pages/Images/helpers.webp";
import Navbar from "../Pages/Navbar/Navbar";
import EmployerNavbar from "../Pages/Navbar/EmployerNavbar";
import EmployeeNavbar from "../Pages/Navbar/JobSeekerNavbar";
import AgencyNavbar from "../Pages/Navbar/AgencyNavbar";
import AdminNavbar from "../Pages/Navbar/AdminNavbar";
import Footer from "../Footer/Footer"

const user = JSON.parse(localStorage.getItem("user")) || {};

// Determine which Navbar to show
const renderNavbar = () => {
  if (user.user_type === "employer") {
    return <EmployerNavbar />;
  } else if (user.user_type === "job seeker") {
    return <EmployeeNavbar />;
  } else if (user.user_type === "agency") {
    return <AgencyNavbar />;
  } else if (user.user_type === "admin") {
    return <AdminNavbar />;
  } else {
    return <Navbar />;
  }
};

const AboutUs = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isArabic = i18n.language === 'ar';

  const handleContactUs = () => {
    navigate('/contactus');
  };

  return (
    <>
      {renderNavbar()}
      <div className="about-container">
        {isArabic ? (
          <>
            <h2 className="about-title">من نحن</h2>

            <p className="about-text">
              نحن، <span className="highlight">جولف وركر (Gulf Worker)</span>، فريق من المهنيين الملتزمين بالمبادئ الأخلاقية والعمل على تحسين ظروف الباحثين عن عمل والعمالة المنزلية.
            </p>

            <p className="about-text">
              تأسست منصتنا الإلكترونية في عام 2016 لمساعدة أصحاب العمل والعمال على حد سواء وتمكينهم من اتخاذ قرارات مدروسة. أسلوب عملنا بسيط ومباشر؛ <strong>نحن نربط بين العمال وأصحاب العمل بسلاسة</strong>، مما يوفر لكليهما تجربة توظيف عادلة.
            </p>

            <p className="about-text">
              لقد ولت الأيام التي كان يُطلب فيها من العمالة المنزلية دفع رسوم باهظة وغير أخلاقية لوكالات التوظيف. في جولف وركر، نحن ملتزمون بتوفير وصول فوري لكلا الطرفين من خلال ملفات شخصية منظمة وفحص دقيق وعملية توظيف مبسطة.
            </p>

            {/* Why Choose Us Section */}
            <div className="why-container">
              <h2 className="why-title">لماذا تختارنا؟</h2>

              <h3 className="sub-title">أخلاقي</h3>
              <p className="about-text">
                يدافع جولف وركر عن ممارسات التوظيف العادلة من خلال ربط العمال ومقدمي الرعاية وغيرهم من الباحثين عن عمل بأصحاب العمل دون فرض أي رسوم على العمال. يساعد هذا النهج في منع الاستغلال وضمان عدم إثقال كاهل العمال بالديون قبل بدء وظائفهم. نحن نتبع الممارسات الأخلاقية ونتطلع إلى تحسين نظامنا في الأيام القادمة.
              </p>

              <div className="followers-image-container">
                <img src={followersImage} alt="أكثر من 150,000 متابع" className="followers-image" />
              </div>

              <h3 className="sub-title">مسؤول</h3>
              <p className="about-text">
                نحن نتحمل المسؤولية الكاملة ولدينا نفس القدر من الشغف بما نقوم به. تحفزنا قيمنا الأخلاقية على بذل المزيد من الجهد والعمل من أجل <strong>تطوير سوق عمل حر وعادل</strong>. بينما توجد وكالات توظيف تستغل المرشحين، نعمل في جولف وركر بكامل طاقتنا وخارج نطاق قدرتنا لضمان وصولهم إلى عملية توظيف عادلة ومنصفة.
              </p>
            </div>

            {/* For Helpers Section */}
            <div className="helpers-container">
              <h3 className="sub-title">للعمال</h3>
              <p className="about-text">
                نحن نقدم <strong>وصولاً مجانياً إلى سوق العمل المنزلي عبر الإنترنت</strong>. لقد صممنا سوقاً مجانياً يمكنك من خلاله <span className="highlight">الاتصال بأصحاب العمل المحتملين مباشرة</span>؛ نحن نعمل لمساعدتك في الحصول على عمل لدى صاحب العمل المناسب ونسعى جاهدين إلى <strong>بناء علاقات عمل ودية وطويلة الأجل</strong>. ما عليك سوى تقديم ملفك الشخصي مجاناً على منصتنا وانتظار توظيفك مع العائلة التي تختارها.
              </p>

              <div className="helpers-image-container">
                <img src={helpersImage} alt="توظيف مباشر - توفير رسوم الوكالة - بدون ديون" className="helpers-image" />
              </div>
            </div>

            {/* For Employers Section */}
            <div className="employers-container">
              <h3 className="sub-title">لأصحاب العمل</h3>
              <p className="about-text">
                تم تصميم منصتنا الإلكترونية لتمنحك إمكانية الوصول إلى أفضل العمالة المنزلية. تضم قائمة العمالة لدينا <strong>مرشحين ذوي خبرة وكفاءة</strong>. لا يهم ما إذا كنت في هونغ كونغ أو سنغافورة أو دبي؛ نحن نساعدك في <span className="highlight">التواصل مع العامل الذي تختاره</span>. ما عليك سوى اختيار الموقع ونشر وظيفة والبدء في تلقي الطلبات والاستعداد للعثور على عامل لعائلتك.
              </p>
            </div>

            {/* Mission Statement */}
            <div className="mission-container">
              <h3 className="sub-title">بيان المهمة</h3>
              <p className="about-text">
                مهمتنا هي توفير <strong>بيئة توظيف عادلة</strong> وتقديم المزيد من الميزات على منصتنا لجعلها أفضل. نريد الوصول إلى أكبر عدد ممكن من المرشحين وأصحاب العمل من أجل <strong>الحصول على وظيفة جديدة بأمان</strong>. نحن فخورون بكوننا إحدى المنصات الرائدة لتوظيف العمالة المنزلية. هل أنت مستعد <span className="highlight">للانضمام إلى مجتمعنا؟</span>
              </p>
            </div>

            {/* Contact Us */}
            <div className="contact-container">
              <h3 className="sub-title">اتصل بنا</h3>
              <p className="about-text">
                يقع مكتبنا الرئيسي في A-205، الطابق الثاني، مجمع محطة نيرول، نيرول، نافي مومباي - 400708، الهند. <br />
                هاتف: <span className="highlight">+974 5078 3800</span>
              </p>
            </div>

            {/* Got a Question Section */}
            <div className="question-container">
              <h2>لديك سؤال؟</h2>
              <p>
                نحن هنا لمساعدتك. تحقق من الأسئلة الشائعة لدينا أو أرسل بريداً إلكترونياً إلى فريق الدعم.
              </p>
              <button 
                className="contact-btn" 
                onClick={handleContactUs}
              >
                تواصل معنا
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="about-title">About Us</h2>

            <p className="about-text">
              We, <span className="highlight">Gulf Worker</span>, are a team of ethical professionals dedicated to the betterment of the job seekers and domestic workers.
            </p>

            <p className="about-text">
              Founded in 2016, our online platform is designed to assist the employers as well as the helpers by enabling them to make informed decisions. Our working method is simple and straight;{" "}
              <strong>we connect helpers and employers seamlessly</strong>, providing both of them a fair recruitment experience.
            </p>

            <p className="about-text">
              Gone are the days when the domestic helpers were required to pay unethical, hefty fees to the employment agencies. At Gulf Worker, we are committed to providing instant access to both the parties through well structured profiles, screening and a streamlined hiring process.
            </p>

            {/* Why Choose Us Section */}
            <div className="why-container">
              <h2 className="why-title">Why choose us?</h2>

              <h3 className="sub-title">Ethical</h3>
              <p className="about-text">
                Gulf Worker advocates for fair employment practices by connecting helpers, caregivers, and other job seekers with employers without charging the workers any fees. This approach helps to prevent exploitation and ensure that the workers are not burdened with debt before they start their jobs. We follow ethical practices and look forward to better our system in the days to come.
              </p>

              <div className="followers-image-container">
                <img src={followersImage} alt="More than 150,000 Followers" className="followers-image" />
              </div>

              <h3 className="sub-title">Responsible</h3>
              <p className="about-text">
                We are highly responsible and equally passionate about what we are doing. Our moral values motivate us to strive even more and work towards the cause of <strong>developing a free and fair job market</strong>. While there are several agencies that are taking advantage of the candidates, we at Gulf Worker are working full length and beyond our capacity to ensure they get access to a fair and equitable hiring process.
              </p>
            </div>

            {/* For Helpers Section */}
            <div className="helpers-container">
              <h3 className="sub-title">For Helpers</h3>
              <p className="about-text">
                We provide <strong>FREE access to the domestic job market online</strong>. We have engineered a free marketplace wherein you can{" "}
                <span className="highlight">get in touch with potential employers directly</span>; we work to help you get placed with the right employer and strive to{" "}
                <strong>build long-term cordial working relationships</strong>. Just submit your profile for free on our platform and await your placement with the family of your choice.
              </p>

              <div className="helpers-image-container">
                <img src={helpersImage} alt="Direct Hire - Save Agency Fees - No Debt Bondage" className="helpers-image" />
              </div>
            </div>

            {/* For Employers Section */}
            <div className="employers-container">
              <h3 className="sub-title">For Employers</h3>
              <p className="about-text">
                Our online platform is designed to give you access to the best domestic helpers. Our helper listing consists of{" "}
                <strong>candidates with experience and expertise</strong>. It doesn't matter whether you are in Hong Kong, Singapore or Dubai; we assist you in{" "}
                <span className="highlight">connecting with the helper of your choice</span>. Just choose the location, post a job, start receiving applications and get set to find a helper for your family.
              </p>
            </div>

            {/* Mission Statement */}
            <div className="mission-container">
              <h3 className="sub-title">Mission Statement</h3>
              <p className="about-text">
                Our mission is to provide a <strong>fair recruitment environment</strong> and introduce more features on our platform to make it even better. We want to reach out to as many candidates and employers as possible in order to{" "}
                <strong>safely get a new job</strong>. We are proud to be one of leading platform for hiring domestic staffs. Ready to{" "}
                <span className="highlight">join our community ?</span>
              </p>
            </div>

            {/* Contact Us */}
            <div className="contact-container">
              <h3 className="sub-title">Contact Us</h3>
              <p className="about-text">
                Our head office is located at A-205, 2nd Floor, Nerul Station Complex, Nerul, Navi Mumbai – 400708, India. <br />
                Tel: <span className="highlight">+974 5078 3800</span>
              </p>
            </div>

            {/* Got a Question Section */}
            <div className="question-container">
              <h2>Got a question?</h2>
              <p>
                We are here to help you. Check out our FAQs or send an email to our support team.
              </p>
              <button 
                className="contact-btn" 
                onClick={handleContactUs}
              >
                Contact Us
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;